var map = {
	"./colorDepth": 10554,
	"./colorDepth.js": 10554,
	"./cookieEnabled": 22287,
	"./cookieEnabled.js": 22287,
	"./deviceMemory": 28660,
	"./deviceMemory.js": 28660,
	"./doNotTrack": 90112,
	"./doNotTrack.js": 90112,
	"./language": 4226,
	"./language.js": 4226,
	"./screenResolution": 30274,
	"./screenResolution.js": 30274,
	"./userAgent": 28063,
	"./userAgent.js": 28063,
	"./vendor": 20726,
	"./vendor.js": 20726
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 61240;